import './login.scss';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { trackEvent, identifyUser } from 'rubriq/helpers/mixpanel';
import { Controls, validators } from 'shared/helper/form';
import Link from 'shared/components/Link';
import { T, useTranslate } from 'shared/helper/translate';
import { recordSignInClick } from '../../helpers/gtm';
import ProvidersV2 from './ProvidersV2';
var Form = Controls.Form,
  Text = Controls.Text,
  Password = Controls.Password;
var isEmail = validators.isEmail,
  notEmpty = validators.notEmpty;
var defaultValues = {
  email: '',
  password: ''
};
function LogingV2(_ref) {
  var processing = _ref.processing,
    providers = _ref.providers,
    referringUrl = _ref.referringUrl,
    loginUser = _ref.loginUser,
    _ref$onUserLoginAttem = _ref.onUserLoginAttempt,
    onUserLoginAttempt = _ref$onUserLoginAttem === void 0 ? function () {} : _ref$onUserLoginAttem;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  var handleLoginUser = function handleLoginUser(user) {
    recordSignInClick({
      buttonId: 'login_button',
      buttonText: t('sign-in')
    });
    trackEvent('Login Attempted', {
      email_attempted: user.email,
      landing_page: window.location.pathname,
      device: navigator.userAgent
    });
    return loginUser(user).then(function (loggedInUser) {
      var _loggedInUser$user, _loggedInUser$user2;
      if (!(loggedInUser !== null && loggedInUser !== void 0 && loggedInUser.loggedIn)) {
        trackEvent('Login Failed', {
          reason: (loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.error) || 'invalid_credentials',
          email_attempted: user.email,
          landing_page: window.location.pathname
        });
        return onUserLoginAttempt(loggedInUser);
      }
      identifyUser(loggedInUser.email, {
        $email: loggedInUser.email
      });
      var lastLogin = Number(loggedInUser === null || loggedInUser === void 0 || (_loggedInUser$user = loggedInUser.user) === null || _loggedInUser$user === void 0 ? void 0 : _loggedInUser$user.lastLogin);
      var lastLoginSeconds = Number(loggedInUser === null || loggedInUser === void 0 || (_loggedInUser$user2 = loggedInUser.user) === null || _loggedInUser$user2 === void 0 ? void 0 : _loggedInUser$user2.lastLogin);
      var lastLoginDateTime = Number.isFinite(lastLoginSeconds) ? new Date(lastLoginSeconds * 1000).toISOString() : null;
      var daysSinceLastLogin = Number.isFinite(lastLogin) ? Math.floor((Date.now() - lastLogin * 1000) / (1000 * 60 * 60 * 24)) : null;
      setTimeout(function () {
        var _loggedInUser$hasLogg;
        trackEvent('Session Started', {
          days_since_last_login: daysSinceLastLogin,
          last_login: lastLoginDateTime,
          email: loggedInUser.email
        });
        trackEvent('Login', {
          device: navigator.userAgent,
          returning: (_loggedInUser$hasLogg = loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.hasLoggedInBefore) !== null && _loggedInUser$hasLogg !== void 0 ? _loggedInUser$hasLogg : false,
          landing_page: window.location.pathname,
          email: loggedInUser.email
        });
      }, 0);
      return onUserLoginAttempt(loggedInUser);
    }).catch(function (error) {
      trackEvent('Login Failed', {
        reason: (error === null || error === void 0 ? void 0 : error.message) || 'unknown',
        email_attempted: user.email,
        landing_page: window.location.pathname
      });
      throw error;
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "new-login w-50 mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 text-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center w-75 mx-auto"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "fw-semibold"
  }, /*#__PURE__*/React.createElement(T, {
    source: "sign-in"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-6 have-account"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/register"
  }, /*#__PURE__*/React.createElement(T, {
    source: "I don't have an account"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "w-75 mx-auto"
  }, /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    className: "login-form clearfix",
    onSubmit: handleLoginUser,
    testAttribute: "login-form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Text, {
    placeholder: "work-personal-email",
    messages: {
      isEmail: 'emailAddressInvalidFormat'
    },
    name: "email",
    validators: {
      isEmail: isEmail
    },
    styles: {
      wrapper: 'row m-0',
      label: 'col-4',
      controlsWrapper: 'col p-0'
    },
    ariaLabel: "work-personal-email"
  })), /*#__PURE__*/React.createElement(Password, {
    placeholder: "Password",
    messages: {
      notEmpty: 'Please enter your password.'
    },
    name: "password",
    validators: {
      notEmpty: notEmpty
    },
    styles: {
      wrapper: 'mb-0'
    }
  }), /*#__PURE__*/React.createElement("button", {
    id: "login_button",
    disabled: processing,
    type: "submit",
    className: "agree-button w-100",
    "aria-label": t('sign-in')
  }, processing && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "ms-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "sign-in"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "my-4 text-center"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/login/forgot-password"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mx-3 forgot text-underline"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Can't sign in?"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center my-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "divider-line w-50"
  }), /*#__PURE__*/React.createElement("span", {
    className: "mx-3 split"
  }, /*#__PURE__*/React.createElement(T, {
    source: "or"
  })), /*#__PURE__*/React.createElement("div", {
    className: "divider-line w-50"
  }))), /*#__PURE__*/React.createElement(ProvidersV2, {
    providers: providers,
    referringUrl: referringUrl
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-start"
  }, /*#__PURE__*/React.createElement("p", {
    className: "terms my-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "privacy-policy"
  })), /*#__PURE__*/React.createElement("p", {
    className: "terms my-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "terms-and-conditions"
  }))))));
}
export default LogingV2;